import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ReduxStateType } from "redux-store/types";

interface InitialState {
  data: { [code: string]: any };
  status: ReduxStateType;
}
export enum FileTypes {
  IMAGE = "image/jpeg",
  PDF_DOCUMENT = "application/pdf",
  DOC = "application/msword",
}

const initialState: InitialState = {
  data: {},
  status: ReduxStateType.INIT,
};

const getFileSlice = createSlice({
  name: "getFile",
  initialState,
  reducers: {
    getResponseFileStart: (
      state,
      action: PayloadAction<{
        url: string;
        type: FileTypes;
        callback?: Function;
      }>
    ) => {
      state.status = ReduxStateType.LOADING;
    },
    getResponseFileSuccess: (state, action: PayloadAction<any>) => {
      state.status = ReduxStateType.SUCCESS;
      state.data = {
        ...state.data,
        [action.payload.key]: action.payload,
      };
    },
    getResponseFileFailed: (state) => {
      state.status = ReduxStateType.ERROR;
    },

    resetResponseFile: () => {
      return { ...initialState };
    },
  },
});

export const {
  getResponseFileStart,
  getResponseFileSuccess,
  getResponseFileFailed,
  resetResponseFile,
} = getFileSlice.actions;

export default getFileSlice.reducer;
